export const minionEarnConfig = {
  SPARKEV_MIN_AMOUNT: 200,
  SPECIAL_POINT: 3,
  MALL_SHOP_MIN_AMOUNT: 200,
  MALL_SHOP_POINT: 1,
  DAILY_POINT_CAP: 3,
};
